const sections = {
  ClientData: {
    value: 'CLIENT_DATA',
    label: 'form.order.clientData.title'
  },
  Carrier: {
    value: 'CARRIER',
    label: 'form.order.carrier.title'
  },
  OrderInfo: {
    value: 'ORDER_INFO',
    label: 'form.order.orderInfo.title'
  },
  Attachments: {
    value: 'ATTACHMENTS',
    label: 'form.order.attachmentsTitle'
  },
  Loading: {
    value: 'LOADING',
    label: 'form.order.cargo.orderPointType.LOADING'
  },
  Unloading: {
    value: 'UNLOADING',
    label: 'form.order.cargo.orderPointType.UNLOADING'
  },
  FerryPassage: {
    value: 'FERRY_PASSAGE',
    label: 'form.order.cargo.orderPointType.FERRY_PASSAGE'
  },
  CustomsControl: {
    value: 'CUSTOMS_CONTROL',
    label: 'form.order.cargo.orderPointType.CUSTOMS_CONTROL'
  },
  Custom: {
    value: 'CUSTOM',
    label: 'form.order.cargo.orderPointType.CUSTOM'
  }
}
export default sections
